import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { DropdownSelectable } from 'components/common/dropdown';

const PageSortBy = (props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="sort">
      <DropdownSelectable
        category="transparent"
        dropdownTextMinWidth="120px"
        label={messages.commonSort}
        size="medium"
        showSelectedText={true}
        {...props}
      />

      <style jsx>{`
        .sort {
          display: inline-block;
        }
        .sort :global(.wrapper > button) {
          background-color: transparent;
          color: ${theme.pageTextColorLighter};
          font-size: 1.4rem;
          font-weight: 700;
          padding: 1px 6px;
        }
        .sort :global(.wrapper > button:hover) {
          color: ${theme.pageTextColor};
        }
      `}</style>
    </div>
  );
};

export default PageSortBy;
